(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════
     FLOATING HEARTS
     ═══════════════════════════════════════════════════════════ */
  function initFloatingHearts(container) {
    if (!container) return;
    var HEART_COUNT = 18;
    var heartSVG =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="none">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>';

    for (var i = 0; i < HEART_COUNT; i++) {
      var el = document.createElement('span');
      el.className = 'val-hero__heart val-animate-float-heart';
      el.innerHTML = heartSVG;
      var size = 10 + Math.random() * 18;
      el.style.left = Math.random() * 100 + '%';
      el.style.width = size + 'px';
      el.style.height = size + 'px';
      el.style.animationDuration = (8 + Math.random() * 12) + 's';
      el.style.animationDelay = (Math.random() * 10) + 's';
      el.style.opacity = 0.15 + Math.random() * 0.25;
      container.appendChild(el);
    }
  }

  /* ═══════════════════════════════════════════════════════════
     COUNTDOWN TIMER
     ═══════════════════════════════════════════════════════════ */
  function initCountdown(container) {
    if (!container) return;
    var targetStr = container.getAttribute('data-target-date');
    if (!targetStr) return;

    var daysEl = container.querySelector('[data-unit="days"]');
    var hoursEl = container.querySelector('[data-unit="hours"]');
    var minutesEl = container.querySelector('[data-unit="minutes"]');
    var secondsEl = container.querySelector('[data-unit="seconds"]');
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    function getTarget() {
      var parts = targetStr.split('-');
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10) - 1;
      var day = parseInt(parts[2], 10);
      var target = new Date(year, month, day);
      // If date already passed, try next year
      if (target <= new Date()) {
        target.setFullYear(target.getFullYear() + 1);
      }
      return target;
    }

    var target = getTarget();

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function tick() {
      var now = new Date();
      var diff = target - now;
      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      daysEl.textContent = pad(d);
      hoursEl.textContent = pad(h);
      minutesEl.textContent = pad(m);
      secondsEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ═══════════════════════════════════════════════════════════
     GIFT FINDER QUIZ — AI-powered via chat agent
     ═══════════════════════════════════════════════════════════ */
  function initQuiz(container) {
    if (!container) return;

    var WEBHOOK_URL = 'https://chat.dubai-aroma.co.za/webhook/bf4dd093-bb02-472c-9454-7ab9af97bd1d';
    var VIBE_LABELS = {
      classic: 'Classic & Elegant',
      bold: 'Bold & Adventurous',
      cozy: 'Cozy & Thoughtful',
      creative: 'Creative & Unique'
    };
    var WHO_LABELS = { her: 'Her', him: 'Him', us: 'Us (a couple)' };

    var state = { step: 0, answers: {} };
    var steps = container.querySelectorAll('.val-quiz__step');

    // Result container
    var aiResultsWrap = container.querySelector('.val-quiz__ai-results');
    var loadingText = container.querySelector('.val-quiz__loading-text');
    var loadingSub = container.querySelector('.val-quiz__loading-sub');

    function showStep(n) {
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === n);
      });
    }

    // Start button
    var startBtn = container.querySelector('.val-quiz__start-btn');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        state.step = 1;
        showStep(1);
      });
    }

    // Option buttons
    var optionBtns = container.querySelectorAll('.val-quiz__option');
    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var questionStep = parseInt(btn.closest('.val-quiz__step').getAttribute('data-step'), 10);
        var value = btn.getAttribute('data-value');

        // Highlight selected
        btn.closest('.val-quiz__options').querySelectorAll('.val-quiz__option').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        state.answers[questionStep] = value;

        if (questionStep === 1) {
          setTimeout(function () {
            state.step = 2;
            showStep(2);
          }, 300);
        } else if (questionStep === 2) {
          // Show loading step
          state.step = 3;
          showStep(3);
          if (loadingText) loadingText.textContent = 'Consulting Cupid...';
          if (loadingSub) loadingSub.textContent = 'Finding your perfect match';
          fetchAIRecommendation();
        }
      });
    });

    // AI fetch
    function fetchAIRecommendation() {
      var who = WHO_LABELS[state.answers[1]] || 'Her';
      var vibe = VIBE_LABELS[state.answers[2]] || 'Classic & Elegant';
      var sessionId = 'quiz_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

      var prompt = "I'm looking for a Valentine's Day gift perfume recommendation. " +
        "The gift is for: " + who + ". " +
        "Their personality/vibe is: " + vibe + ". " +
        "Please recommend exactly 2 perfumes from your store that would make the perfect Valentine's Day gift. " +
        "For each perfume please provide: the product name, price, a brief romantic reason why it's perfect for Valentine's Day, and the product URL on your website. " +
        "Keep it concise and romantic.";

      fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ chatInput: prompt, sessionId: sessionId })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var reply = data.output || data.message || '';
          renderAIResults(reply);
          state.step = 4;
          showStep(4);
        })
        .catch(function (err) {
          console.error('Quiz AI error:', err);
          renderAIError();
          state.step = 4;
          showStep(4);
        });
    }

    // ── Parse product card data from a text block ──
    function parseProductBlock(text) {
      var lines = text.split(/\n/).map(function (l) { return l.trim(); }).filter(function (l) { return l; });
      if (lines.length === 0) return null;

      var data = { number: null, title: null, price: null, imageUrl: null, link: null, details: [], descriptions: [] };

      // Extract number from first line
      var firstLine = lines[0];
      var numMatch = firstLine.match(/^(\d+)/);
      if (numMatch) {
        data.number = numMatch[1];
        if (firstLine.length < 5) {
          lines.splice(0, 1);
        } else {
          lines[0] = firstLine.replace(/^\d+[\.\s]*/, '').trim();
        }
      }

      var remainingLines = [];

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];

        // Detect Image URL (skip all image lines, keep only the first)
        if (line.toLowerCase().indexOf('image:') === 0) {
          var potentialUrl = line.substring(6).trim();
          if (!data.imageUrl && potentialUrl) {
            data.imageUrl = potentialUrl;
          } else if (!data.imageUrl && i + 1 < lines.length && /^https?:\/\//i.test(lines[i + 1])) {
            data.imageUrl = lines[i + 1];
            i++;
          }
          continue;
        }
        if (/^https?:\/\/cdn\.shopify\.com/i.test(line)) {
          if (!data.imageUrl) data.imageUrl = line;
          continue;
        }

        // Detect Price (standalone line like "R849" or within title)
        if (!data.price) {
          var priceMatch = line.match(/^R\s?(\d[\d,]*)/);
          if (priceMatch) {
            data.price = priceMatch[1].replace(/,/g, '');
            continue;
          }
        }

        // Detect Product Link
        if (!data.link && (line.toLowerCase().indexOf('view product') !== -1 || line.toLowerCase().indexOf('dubai-aroma.co.za/products/') !== -1)) {
          var urlMatch = line.match(/https?:\/\/[^\s<]+/i);
          if (urlMatch) {
            data.link = urlMatch[0];
          } else if (i + 1 < lines.length && /^https?:\/\//i.test(lines[i + 1])) {
            data.link = lines[i + 1];
            i++;
          }
          continue;
        }

        // Skip "Qualifies for FREE delivery" lines
        if (/qualifies for free delivery/i.test(line)) continue;

        // Detect detail lines (Key: Value format)
        if (/^(Main Accords|Notes Pyramid|Top Notes?|Middle Notes?|Base Notes?|Longevity|Sillage)\s*:/i.test(line)) {
          var parts = line.split(':');
          var detailContent = parts.slice(1).join(':').trim();
          if (detailContent) {
            data.details.push({ label: parts[0].trim(), content: detailContent });
          }
          continue;
        }
        // Skip standalone section headers (e.g. "Notes Pyramid" without colon)
        if (/^(Notes Pyramid|Fragrance Notes)\s*$/i.test(line)) continue;

        if (line) remainingLines.push(line);
      }

      // First remaining line is title
      if (remainingLines.length > 0) {
        data.title = remainingLines.shift();
        // Extract price from title if embedded like "Product Name (R849)"
        if (!data.price) {
          var titlePrice = data.title.match(/\(R(\d[\d,]*)\)/);
          if (titlePrice) {
            data.price = titlePrice[1].replace(/,/g, '');
            data.title = data.title.replace(/\s*\(R\d[\d,]*\)/, '').trim();
          }
        }
        // Clean "Qualifies..." from title
        data.title = data.title.replace(/\s*-?\s*\(?Qualifies for FREE delivery\)?!?\s*/i, '').trim();
      }

      // Rest are descriptions
      data.descriptions = remainingLines.filter(function (ln) {
        return ln.length > 5 && !/^\d+$/.test(ln);
      });

      return data;
    }

    // ── Build a valentine-themed product card HTML ──
    function buildProductCardHTML(data) {
      var html = '<div class="val-quiz__ai-card">';

      if (data.imageUrl) {
        html += '<div class="val-quiz__ai-card-img-wrap">';
        html += '<img src="' + data.imageUrl + '" alt="' + (data.title || 'Product') + '" class="val-quiz__ai-card-img" onerror="this.parentElement.style.display=\'none\'">';
        html += '</div>';
      }

      if (data.number) {
        html += '<div class="val-quiz__ai-card-number">' + data.number + '</div>';
      }

      if (data.title) {
        html += '<h4 class="val-quiz__ai-card-name">' + data.title + '</h4>';
      }

      if (data.price) {
        html += '<div class="val-quiz__ai-card-price">R' + data.price;
        if (parseInt(data.price) >= 849) {
          html += '<span class="val-quiz__ai-card-badge">Free Delivery</span>';
        }
        html += '</div>';
      }

      // Detail rows (notes, accords, etc.)
      data.details.forEach(function (d) {
        html += '<div class="val-quiz__ai-card-detail">';
        html += '<span class="val-quiz__ai-card-detail-label">' + d.label + '</span>';
        html += '<span class="val-quiz__ai-card-detail-content">' + d.content + '</span>';
        html += '</div>';
      });

      // Description lines
      data.descriptions.forEach(function (desc) {
        html += '<p class="val-quiz__ai-card-desc">' + desc + '</p>';
      });

      if (data.link) {
        html += '<a href="' + data.link + '" target="_blank" class="val-quiz__ai-card-link">View Product →</a>';
      }

      html += '</div>';
      return html;
    }

    function renderAIResults(rawText) {
      if (!aiResultsWrap) return;

      // Clean markdown
      rawText = rawText.replace(/\*\*/g, '').replace(/\*/g, '');

      // Split into paragraphs and group product blocks.
      // Strategy: everything between one product number and the next belongs
      // to that product. Text before the first number is intro.
      var chunks = rawText.split(/\n\n+/);
      var introTexts = [];
      var productBlocks = [];
      var currentProduct = null;

      chunks.forEach(function (chunk) {
        var trimmed = chunk.trim();
        if (!trimmed) return;

        if (/^\d+(\.|\s|$)/.test(trimmed)) {
          // New product block — push previous one if exists
          if (currentProduct) productBlocks.push(currentProduct);
          currentProduct = trimmed;
        } else if (currentProduct) {
          // Append everything to current product until next numbered block
          currentProduct += '\n\n' + trimmed;
        } else {
          // Before any product — intro text
          introTexts.push(trimmed);
        }
      });
      if (currentProduct) productBlocks.push(currentProduct);

      // Build HTML
      var html = '';

      // Intro text
      if (introTexts.length > 0) {
        html += '<p class="val-quiz__ai-intro">' + introTexts.join('<br>') + '</p>';
      }

      // Product cards in a grid
      if (productBlocks.length > 0) {
        html += '<div class="val-quiz__ai-grid">';
        productBlocks.forEach(function (block) {
          var data = parseProductBlock(block);
          if (data) html += buildProductCardHTML(data);
        });
        html += '</div>';
      }

      aiResultsWrap.innerHTML = html;
    }

    // Error fallback
    function renderAIError() {
      if (!aiResultsWrap) return;
      aiResultsWrap.innerHTML =
        '<div class="val-quiz__ai-error">' +
        '<p>Cupid got a little lost! 💘</p>' +
        '<p>We couldn\'t fetch recommendations right now. Please try again in a moment.</p>' +
        '</div>';
    }

    // Restart buttons (there may be more than one)
    var restartBtns = container.querySelectorAll('.val-quiz__restart-btn');
    restartBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        state = { step: 0, answers: {} };
        optionBtns.forEach(function (o) { o.classList.remove('is-selected'); });
        if (aiResultsWrap) aiResultsWrap.innerHTML = '';
        showStep(0);
      });
    });

    // Initialize at intro
    showStep(0);
  }

  /* ═══════════════════════════════════════════════════════════
     PRODUCT TAB FILTERING
     ═══════════════════════════════════════════════════════════ */
  function initTabs(container) {
    if (!container) return;
    var tabs = container.querySelectorAll('.val-tab');
    var cards = container.querySelectorAll('.val-product-card');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var category = tab.getAttribute('data-tab');

        // Update active tab
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        // Filter cards
        var delay = 0;
        cards.forEach(function (card) {
          var cardCat = card.getAttribute('data-category');
          if (category === 'all' || cardCat === category) {
            card.classList.remove('is-hidden');
            card.style.animationDelay = delay + 's';
            card.style.animation = 'none';
            // Force reflow
            void card.offsetHeight;
            card.style.animation = '';
            delay += 0.08;
          } else {
            card.classList.add('is-hidden');
          }
        });
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     ADD TO CART (Shopify AJAX API)
     ═══════════════════════════════════════════════════════════ */
  function initAddToCart(container) {
    if (!container) return;
    var buttons = container.querySelectorAll('[data-val-add-to-cart]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="val-spin"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            btn.classList.add('is-added');
            btn.innerHTML =
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';

            // Update cart count in header if possible
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var countEls = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
                countEls.forEach(function (el) { el.textContent = cart.item_count; });
              })
              .catch(function () { });

            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.innerHTML = originalHTML;
              btn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          });
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     SCROLL ANIMATION (Intersection Observer)
     ═══════════════════════════════════════════════════════════ */
  function initScrollAnimations(container) {
    if (!container || !('IntersectionObserver' in window)) return;

    var elements = container.querySelectorAll('.val-scroll-trigger');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('val-animate-fade-in-up');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -50px 0px' }
    );

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ═══════════════════════════════════════════════════════════
     INIT ON DOM READY — loop ALL .val-section wrappers
     ═══════════════════════════════════════════════════════════ */
  function init() {
    var sections = document.querySelectorAll('.val-section');
    if (!sections.length) return;

    sections.forEach(function (section) {
      initFloatingHearts(section.querySelector('.val-hero__hearts'));
      initCountdown(section.querySelector('.val-countdown'));
      initQuiz(section.querySelector('.val-quiz'));
      initTabs(section.querySelector('.val-products'));
      initAddToCart(section);
      initScrollAnimations(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor section load/select
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.val-section')) {
        init();
      }
    });
  }
})();
